<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1">
          {{ data1["druidParamName"] }}<em v-if="data1['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data1["price"] }}</span>
        </div>
        <div class="data2">
          {{ `${data2["druidParamName"]}` }}<em v-if="data2['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data2["price"] }}</span>
        </div>
        <div class="data3">
          {{ `${data3["druidParamName"]}` }}<em v-if="data3['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data3["price"] }}</span>
        </div>
        <div class="data4">
          {{ `${data4["druidParamName"]}` }}<em v-if="data4['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data4["price"] }}</span>
        </div>
        <div class="data5">
          {{ `${data5["druidParamName"]}` }}<em v-if="data5['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data5["price"] }}</span>
        </div>
        <div class="data6">
          {{ `${data6["druidParamName"]}` }}<em v-if="data6['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data6["price"] }}</span>
        </div>
        <div class="data7">
          {{ `${data7["druidParamName"]}` }}<em v-if="data7['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data7["price"] }}</span>
        </div>
        <div class="data8">
          {{ `${data8["druidParamName"]}` }}<em v-if="data8['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data8["price"] }}</span>
        </div>
        <div
          class="differPrice1 redColor"
          v-if="chainPrice['differPrice1'] > 0"
        >
          {{ "+" + chainPrice["differPrice1"] }}
        </div>
        <div
          class="differPrice1 greenColor"
          v-if="chainPrice['differPrice1'] < 0"
        >
          {{ chainPrice["differPrice1"] }}
        </div>
        <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">
          —
        </div>
        <div
          class="differPrice2 redColor"
          v-if="chainPrice['differPrice2'] > 0"
        >
          {{ "+" + chainPrice["differPrice2"] }}
        </div>
        <div
          class="differPrice2 greenColor"
          v-if="chainPrice['differPrice2'] < 0"
        >
          {{ chainPrice["differPrice2"] }}
        </div>
        <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">
          —
        </div>
        <div
          class="differPrice3 redColor"
          v-if="chainPrice['differPrice3'] > 0"
        >
          {{ "+" + chainPrice["differPrice3"] }}
        </div>
        <div
          class="differPrice3 greenColor"
          v-if="chainPrice['differPrice3'] < 0"
        >
          {{ chainPrice["differPrice3"] }}
        </div>
        <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">
          —
        </div>
        <div
          class="differPrice4 redColor"
          v-if="chainPrice['differPrice4'] > 0"
        >
          {{ "+" + chainPrice["differPrice4"] }}
        </div>
        <div
          class="differPrice4 greenColor"
          v-if="chainPrice['differPrice4'] < 0"
        >
          {{ chainPrice["differPrice4"] }}
        </div>
        <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">
          —
        </div>
        <div
          class="differPrice5 redColor"
          v-if="chainPrice['differPrice5'] > 0"
        >
          {{ "+" + chainPrice["differPrice5"] }}
        </div>
        <div
          class="differPrice5 greenColor"
          v-if="chainPrice['differPrice5'] < 0"
        >
          {{ chainPrice["differPrice5"] }}
        </div>
        <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">
          —
        </div>
        <div
          class="differPrice6 redColor"
          v-if="chainPrice['differPrice6'] > 0"
        >
          {{ "+" + chainPrice["differPrice6"] }}
        </div>
        <div
          class="differPrice6 greenColor"
          v-if="chainPrice['differPrice6'] < 0"
        >
          {{ chainPrice["differPrice6"] }}
        </div>
        <div class="differPrice6" v-if="chainPrice['differPrice6'] === 0">
          —
        </div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div
            class="title-write"
            @mouseover="changeFlag(5)"
            @click="toTwoPage('/coal/twoPage/industry', '5')"
            :class="{ 'title-write-red': industryFlag === 5 }"
          >
            煤炭快讯
          </div>
          <div
            class="title-write"
            @mouseover="changeFlag(4)"
            @click="toTwoPage('/coal/twoPage/industry', '4')"
            :class="{ 'title-write-red': industryFlag === 4 }"
          >
            行业要闻
          </div>
          <span
            class="title-more fr"
            @click="toTwoPage('/coal/twoPage/industry')"
            >更多 ></span
          >
        </div>
        <div class="banner-right-content" v-if="industryFlag === 5">
          <ul>
            <li v-for="(item, index) in industryList" :key="index">
              <p
                v-if="item.newsType === 1"
                @click="goDetail('/coal/industry', item.id, 5)"
              >
                {{ item.titleName }}
              </p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
        <div class="banner-right-content" v-else>
          <ul>
            <li v-for="(item, index) in industryListTabs" :key="index">
              <p
                v-if="item.newsType === 1"
                @click="goDetail('/coal/industry', item.id, 4)"
              >
                {{ item.titleName }}
              </p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li style="position: relative">
          <img src="../../assets/home/meitanqiye.png" alt="" />
          <span
            @click="toTwoPage('/coal/twoPage/enterprise')"
            style="
              right: 10px;
              position: absolute;
              top: 24px;
              color: #fff;
              cursor: pointer;
            "
          >
            >></span
          >
          <img
            src="../../assets/home/neibu.png"
            style="position: absolute; left: 183px; width: 70px; top: 24px"
            alt=""
          />
          <div class="classification-content">
            <div
              class="classification-content-div"
              v-for="(item, index) in enterpriseList"
              :key="index"
            >
              <i></i>
              <p @click="goDetail('/coal/enterprise', item.collectionTime)">
                {{ item.showTimeword + "煤炭重点企业资讯" }}
              </p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader
            :name="'价格'"
            :flag="false"
            :unit="false"
            :url="'/coal/twoPage/price'"
            :params="{
              title: '价格指数',
              typeList: [
                '产地价格',
                '港口价格',
                '进口价格',
                '仓单价格',
                '期货主力合约价格',
              ],
            }"
          ></ClassificationHeader>
          <div
            style="
              border: 1px solid #ccc;
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
            "
          >
            <span
              class="classification-tabs-two"
              @mouseover="priceFlag = 1"
              @click="
                reportToPage('/coal/twoPage/price', 'issue_coal_place_price')
              "
              :class="{ priceFlag: priceFlag === 1 }"
              style="vertical-align: top"
              >产地价格</span
            >
            <span
              class="classification-tabs-two"
              @mouseover="priceFlag = 2"
              @click="
                reportToPage('/coal/twoPage/price', 'issue_coal_port_price')
              "
              :class="{ priceFlag: priceFlag === 2 }"
              style="vertical-align: top"
              >港口价格</span
            >
            <span
              class="classification-tabs-two"
              @mouseover="priceFlag = 3"
              @click="
                reportToPage('/coal/twoPage/price', 'issue_coal_import_price')
              "
              :class="{ priceFlag: priceFlag === 3 }"
              style="vertical-align: top"
              >进口价格</span
            >
            <span
              class="classification-tabs-two"
              @mouseover="priceFlag = 4"
              @click="
                reportToPage('/coal/twoPage/price', 'issue_coal_receipt_price')
              "
              :class="{ priceFlag: priceFlag === 4 }"
              style="vertical-align: top"
              >仓单价格</span
            >
            <span
              class="classification-tabs-two"
              @mouseover="priceFlag = 5"
              @click="
                reportToPage('/coal/twoPage/price', 'issue_coal_contract_price')
              "
              :class="{ priceFlag: priceFlag === 5 }"
              style="
                font-size: 12px;
                padding: 0 10px;
                width: 54px;
                line-height: revert;
              "
              >期货主力合约价格</span
            >
            <div class="classification-content" v-if="priceFlag === 1">
              <div
                class="classification-content-div price priceBgc"
                v-for="(item, index) in priceOneList"
                :key="index"
                @click="
                  goDetail(
                    '/coal/priceIndex',
                    item.completeOriginalDate,
                    'issue_coal_place_price'
                  )
                "
              >
                <img src="../../assets/home/jiage.jpg" alt="" />
                <p>{{ item.date + "焦煤产地价格" }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="priceFlag === 2">
              <div
                class="classification-content-div price priceBgc"
                v-for="(item, index) in priceTwoList"
                :key="index"
                @click="
                  goDetail(
                    '/coal/priceIndex',
                    item.completeOriginalDate,
                    'issue_coal_port_price'
                  )
                "
              >
                <img src="../../assets/home/jiage.jpg" alt="" />
                <p>{{ item.date + "焦煤港口价格" }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="priceFlag === 3">
              <div
                class="classification-content-div price priceBgc"
                v-for="(item, index) in priceThreeList"
                :key="index"
                @click="
                  goDetail(
                    '/coal/priceIndex',
                    item.completeOriginalDate,
                    'issue_coal_import_price'
                  )
                "
              >
                <img src="../../assets/home/jiage.jpg" alt="" />
                <p>{{ item.date + "焦煤进口价格" }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="priceFlag === 4">
              <div
                class="classification-content-div price priceBgc"
                v-for="(item, index) in priceFourList"
                :key="index"
                @click="
                  goDetail(
                    '/coal/priceIndex',
                    item.completeOriginalDate,
                    'issue_coal_receipt_price'
                  )
                "
              >
                <img src="../../assets/home/jiage.jpg" alt="" />
                <p>{{ item.date + "焦煤仓单价格" }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="priceFlag === 5">
              <div
                class="classification-content-div price priceBgc"
                v-for="(item, index) in priceFiveList"
                :key="index"
                @click="
                  goDetail(
                    '/coal/priceIndex',
                    item.completeOriginalDate,
                    'issue_coal_contract_price'
                  )
                "
              >
                <img src="../../assets/home/jiage.jpg" alt="" />
                <p>{{ item.date + "焦煤期货主力合约价格" }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <span class="fr" @click="toTwoPage('/coal/twoPage/report')">
              >></span
            >
            <img
              src="../../assets/home/neibu.png"
              style="width: 70px; margin-left: 10px"
              alt=""
            />
            <div class="report-tabs">
              <div
                class="tabs-i"
                :class="{ 'tabs-i-hover': reportFlag === 1 }"
                @click="reportToPage('/coal/twoPage/report', 1)"
                @mouseover="changeReportFlag(1)"
              >
                日报
              </div>
              <div
                class="tabs-i"
                :class="{ 'tabs-i-hover': reportFlag === 2 }"
                @click="reportToPage('/coal/twoPage/report', 2)"
                @mouseover="changeReportFlag(2)"
              >
                周报
              </div>
              <div
                class="tabs-i"
                :class="{ 'tabs-i-hover': reportFlag === 3 }"
                @click="reportToPage('/coal/twoPage/report', 3)"
                @mouseover="changeReportFlag(3)"
              >
                月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img
              style="width: 360px"
              src="../../assets/home/yanjiubaogao.png"
              alt=""
            />
            <div v-if="reportFlag === 1">
              <div
                class="classification-content-div"
                v-for="(item, index) in reportList"
                :key="index"
                @click="downloadReport(item)"
              >
                <i></i>
                <p style="width: 200px">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div
                class="classification-content-div"
                v-for="(item, index) in reportListWeek"
                :key="index"
                @click="downloadReport(item)"
              >
                <i></i>
                <p style="width: 200px">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div
                class="classification-content-div"
                v-for="(item, index) in reportListMonth"
                :key="index"
                @click="downloadReport(item)"
              >
                <i></i>
                <p style="width: 200px">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader
            :name="'产量'"
            :flag="false"
            :unit="false"
            :url="'/coal/twoPage/yield'"
            :params="{ title: '产量', typeList: ['原煤产量', '进口量'] }"
          ></ClassificationHeader>
          <span
            class="classification-tabs-three"
            @mouseover="yieldFlag = 1"
            @click="toTwoPage('/coal/twoPage/yield', 'issue_coal_raw_yield', 2)"
            :class="{ stockFlag: yieldFlag === 1 }"
            >原煤产量</span
          >
          <span
            class="classification-tabs-three"
            @mouseover="yieldFlag = 2"
            @click="
              toTwoPage('/coal/twoPage/yield', 'issue_coal_import_yield', 5)
            "
            :class="{ stockFlag: yieldFlag === 2 }"
            >进口量</span
          >
          <div
            class="classification-content"
            v-if="yieldFlag === 1"
            style="margin-top: 5px"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in yieldList"
              :key="index"
              @click="
                goDetail(
                  '/coal/yield',
                  item.completeOriginalDate,
                  'issue_coal_raw_yield'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "原煤产量" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div
            class="classification-content"
            v-if="yieldFlag === 2"
            style="margin-top: 5px"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in yieldListTwo"
              :key="index"
              @click="
                goDetail(
                  '/coal/yield',
                  item.completeOriginalDate,
                  'issue_coal_import_yield'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "焦煤进口量" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li style="position: relative">
          <ClassificationHeader
            :name="'煤炭竞卖预告'"
            :flag="true"
            :unit="false"
            :url="'/coal/twoPage/auctioNotice'"
            :neibu="false"
            :params="{ title: '煤炭竞卖预告' }"
          ></ClassificationHeader>
          <div class="exitClass">
            <div
              class="classification-content-div"
              v-for="(item, index) in coalAuction"
              :key="index"
              style="margin-top: 10px;"
            >
              <i></i>
              <p
                v-if="item.newsType === 1"
                style="
                  max-width: 310px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
                @click="goDetail('/coal/auctioNotice', item.id)"
              >
                {{ item.titleName }}
              </p>
              <p
                v-else
                style="
                  max-width: 310px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
                @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr" style="color: #777777; font-size: 12px">{{
                item.showTime
              }}</span>
            </div>
          </div>
        </li>
        <li class="coal_image">
          <div class="head">
            <em></em>
            <p>煤炭报表</p>
            <img
              src="../../assets/home/neibu.png"
              class="coal_report"
              alt=""
            />
          </div>
          <div class="col_one">
            <div class="col_one-li">
              <div class="col_one-card" @click="goCoalLink">
                <p class="icon">
                  <img src="../../assets/images/report_icon1.png" alt="">
                </p>
                <p class="name overflow1">监测大矿+地方矿+洗煤厂库存、开工率情况详情表</p>
              </div>
            </div>
            <div class="col_one-li">
              <div class="col_one-card" @click="goReportSummary">
                <p class="icon">
                  <img src="../../assets/images/report_icon2.png" alt="">
                </p>
                <p class="name overflow1">监测大矿+地方矿+洗煤厂库存、开工率情况汇总表</p>
              </div>
            </div>
            <div class="col_one-li">
              <div class="col_one-card" @click="goReportServer">
                <p class="icon">
                  <img src="../../assets/images/report_icon3.png" alt="">
                </p>
                <p class="name overflow1">进口煤和国内煤价格对比</p>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader
            :name="'煤矿开工率'"
            :flag="true"
            :unit="false"
            :url="'/coal/twoPage/rate'"
            :neibu="true"
            :params="{ title: '开工率' }"
          ></ClassificationHeader>
          <div class="classification-content">
            <div
              class="classification-content-div"
              v-for="(item, index) in rateList"
              :key="index"
            >
              <i></i>
              <p
                @click="
                  goDetail(
                    '/coal/operatingRate',
                    item.completeOriginalDate,
                    'manual_entry_show_coal_rate'
                  )
                "
              >
                {{ item.date + "煤矿开工率" }}
              </p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader
            :name="'库存'"
            :flag="false"
            :unit="false"
            :url="'/coal/twoPage/stock'"
            :neibu="true"
            :params="{
              title: '库存',
              typeList: [
                '煤矿库存',
                '港口库存',
                '焦化厂焦煤库存',
                '钢厂焦煤库存',
                '总库存',
              ],
            }"
          ></ClassificationHeader>
          <span
            class="classification-tabs-two-stock"
            @mouseover="stockFlag = 'issue_coal_mine_stock'"
            @click="toTwoPage('/coal/twoPage/stock', 'issue_coal_mine_stock')"
            :class="{ stockFlag: stockFlag === 'issue_coal_mine_stock' }"
            style="font-size: 12px"
            >煤矿库存</span
          >
          <span
            class="classification-tabs-two-stock"
            @mouseover="stockFlag = 'issue_coal_port_stock'"
            @click="toTwoPage('/coal/twoPage/stock', 'issue_coal_port_stock')"
            :class="{ stockFlag: stockFlag === 'issue_coal_port_stock' }"
            style="font-size: 12px"
            >港口库存</span
          >
          <span
            class="classification-tabs-two-stock"
            @mouseover="stockFlag = 'issue_coal_cokeplant_stock'"
            @click="
              toTwoPage('/coal/twoPage/stock', 'issue_coal_cokeplant_stock')
            "
            :class="{ stockFlag: stockFlag === 'issue_coal_cokeplant_stock' }"
            style="
              font-size: 12px;
              padding: 0px 10px;
              width: 54px;
              line-height: revert;
            "
            >焦化厂焦煤库存</span
          >
          <span
            class="classification-tabs-two-stock"
            @mouseover="stockFlag = 'issue_coal_steelplant_stock'"
            @click="
              toTwoPage('/coal/twoPage/stock', 'issue_coal_steelplant_stock')
            "
            :class="{ stockFlag: stockFlag === 'issue_coal_steelplant_stock' }"
            style="
              font-size: 12px;
              padding: 0px 10px;
              width: 54px;
              line-height: revert;
            "
            >钢厂焦煤库存</span
          >
          <span
            class="classification-tabs-two-stock"
            @mouseover="stockFlag = 'issue_coal_total_stock'"
            @click="toTwoPage('/coal/twoPage/stock', 'issue_coal_total_stock')"
            :class="{ stockFlag: stockFlag === 'issue_coal_total_stock' }"
            style="font-size: 12px"
            >总库存</span
          >
          <div
            class="classification-content"
            v-if="stockFlag === 'issue_coal_mine_stock'"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in stockOneList"
              :key="index"
              @click="
                goDetail(
                  '/coal/stock',
                  item.completeOriginalDate,
                  'issue_coal_mine_stock'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "煤矿库存" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div
            class="classification-content"
            v-if="stockFlag === 'issue_coal_port_stock'"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in stockTwoList"
              :key="index"
              @click="
                goDetail(
                  '/coal/stock',
                  item.completeOriginalDate,
                  'issue_coal_port_stock'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "港口库存" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div
            class="classification-content"
            v-if="stockFlag === 'issue_coal_cokeplant_stock'"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in stockThreeList"
              :key="index"
              @click="
                goDetail(
                  '/coal/stock',
                  item.completeOriginalDate,
                  'issue_coal_cokeplant_stock'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "焦化厂焦煤库存" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div
            class="classification-content"
            v-if="stockFlag === 'issue_coal_steelplant_stock'"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in stockFourList"
              :key="index"
              @click="
                goDetail(
                  '/coal/stock',
                  item.completeOriginalDate,
                  'issue_coal_steelplant_stock'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "钢厂焦煤库存" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div
            class="classification-content"
            v-if="stockFlag === 'issue_coal_total_stock'"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in stockFiveList"
              :key="index"
              @click="
                goDetail(
                  '/coal/stock',
                  item.completeOriginalDate,
                  'issue_coal_total_stock'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "总库存" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head">
            <em></em>
            <p>
              企业分布
              <b
                style="
                  color: #d3131a;
                  font-size: 18px;
                  margin-left: -5px;
                  font-weight: normal;
                "
                >地图</b
              >
            </p>
            <img
              src="../../assets/home/neibu.png"
              style="width: 70px; margin-left: 10px"
              alt=""
            />
          </div>
          <div class="classification-content" style="margin-top: 5px">
            <img
              style="cursor: pointer"
              src="../../assets/home/map.png"
              @click="goDetail('/coal/map')"
              alt=""
            />
          </div>
        </li>
        <li>
          <ClassificationHeader
            :name="'下游企业'"
            :flag="false"
            :unit="false"
            :url="'/coal/twoPage/downStream'"
            :neibu="true"
            :params="{
              title: '下游企业',
              typeList: ['焦煤可用天数', '焦煤库存'],
            }"
          ></ClassificationHeader>
          <span
            class="classification-tabs-three"
            @mouseover="downstreamFlag = 'issue_coal_company_day'"
            @click="
              toTwoPage('/coal/twoPage/downStream', 'issue_coal_company_day')
            "
            :class="{ stockFlag: downstreamFlag === 'issue_coal_company_day' }"
            >焦煤可用天数</span
          >
          <span
            class="classification-tabs-three"
            @mouseover="downstreamFlag = 'issue_coal_company_total'"
            @click="
              toTwoPage('/coal/twoPage/downStream', 'issue_coal_company_total')
            "
            :class="{
              stockFlag: downstreamFlag === 'issue_coal_company_total',
            }"
            >焦煤库存</span
          >
          <div
            class="classification-content"
            v-if="downstreamFlag === 'issue_coal_company_day'"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in downstreamTwoList"
              :key="index"
              @click="
                goDetail(
                  '/coal/downStream',
                  item.completeOriginalDate,
                  'issue_coal_company_day'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "焦煤可用天数" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div
            class="classification-content"
            v-if="downstreamFlag === 'issue_coal_company_total'"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in downstreamList"
              :key="index"
              @click="
                goDetail(
                  '/coal/downStream',
                  item.completeOriginalDate,
                  'issue_coal_company_total'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "焦煤库存" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader
            :name="'洗煤厂'"
            :flag="false"
            :unit="false"
            :url="'/coal/twoPage/wash'"
            :neibu="true"
            :params="{ title: '洗煤厂', typeList: ['开工率', '库存', '产量'] }"
          ></ClassificationHeader>
          <span
            class="classification-tabs-three-wash"
            @mouseover="washFlag = 'issue_coal_washcoke_rate'"
            @click="toTwoPage('/coal/twoPage/wash', 'issue_coal_washcoke_rate')"
            :class="{ stockFlag: washFlag === 'issue_coal_washcoke_rate' }"
            >开工率</span
          >
          <span
            class="classification-tabs-three-wash"
            @mouseover="washFlag = 'issue_coal_washcoke_stock'"
            @click="
              toTwoPage('/coal/twoPage/wash', 'issue_coal_washcoke_stock')
            "
            :class="{ stockFlag: washFlag === 'issue_coal_washcoke_stock' }"
            >库存</span
          >
          <span
            class="classification-tabs-three-wash"
            @mouseover="washFlag = 'issue_coal_washcoke_yield'"
            @click="
              toTwoPage('/coal/twoPage/wash', 'issue_coal_washcoke_yield')
            "
            :class="{ stockFlag: washFlag === 'issue_coal_washcoke_yield' }"
            >产量</span
          >
          <div
            class="classification-content"
            v-if="washFlag === 'issue_coal_washcoke_rate'"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in washList"
              :key="index"
              @click="
                goDetail(
                  '/coal/wash',
                  item.completeOriginalDate,
                  'issue_coal_washcoke_rate'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "洗煤厂焦煤开工率" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div
            class="classification-content"
            v-if="washFlag === 'issue_coal_washcoke_stock'"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in washTwoList"
              :key="index"
              @click="
                goDetail(
                  '/coal/wash',
                  item.completeOriginalDate,
                  'issue_coal_washcoke_stock'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "洗煤厂焦煤库存" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div
            class="classification-content"
            v-if="washFlag === 'issue_coal_washcoke_yield'"
          >
            <div
              class="classification-content-div"
              v-for="(item, index) in washThreeList"
              :key="index"
              @click="
                goDetail(
                  '/coal/wash',
                  item.completeOriginalDate,
                  'issue_coal_washcoke_yield'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "洗煤厂焦煤产量" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li style="position: relative">
          <img src="../../assets/steel/dashuju.png" alt="" />
          <img
            src="../../assets/home/neibu.png"
            style="width: 70px; position: absolute; left: 200px; top: 25px"
            alt=""
          />
          <span
            style="
              position: absolute;
              right: 10px;
              top: 27px;
              cursor: pointer;
              color: #fff;
            "
            @click="
              toTwoPage(
                '/coal/twoPage/forecast',
                JSON.stringify({ url: '/coal', varieties: '焦煤' })
              )
            "
          >
            >></span
          >
          <div class="classification-content">
            <div
              class="classification-content-div map"
              v-for="(item, index) in forecastList"
              @click="goDetail('/coal/forecast', item.id, '/coal', '焦煤')"
              :key="index"
            >
              <i></i>
              <p>{{ item.showYearTime + item.predictType + "价格预测" }}</p>
              <span class="fr">{{ item.showEndTime }}</span>
            </div>
          </div>
        </li>
        <li style="position: relative">
          <ClassificationHeader
            :name="'技术及标准'"
            :flag="true"
            :unit="false"
            :url="'/coal/twoPage/standard'"
            :neibu="true"
            :params="{ title: '技术及标准' }"
          ></ClassificationHeader>
          <div class="exitClass">
            <div
              class="classification-content-div"
              v-for="(item, index) in standardList"
              :key="index"
            >
              <i></i>
              <p
                style="
                  width: 200px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
                @click="downloadStandard(item)"
              >
                {{ item.fileTitle }}
              </p>
              <span class="fr" style="color: #777777; font-size: 12px">{{
                item.showTime
              }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
      custom-class="previewDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="980px"
      :visible.sync="industrialFlag"
    >
      <CokeIndustrial
        :chainPrice="chainPrice"
        :chainTitle="chainTitle"
        :data1="data1"
        :data2="data2"
        :data3="data3"
        :data4="data4"
        :data5="data5"
        :data6="data6"
        :data7="data7"
        :data8="data8"
        @closeIndustrialCh="closeIndustrial"
      ></CokeIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import ClassificationHeader from "@/components/common/ClassificationHeader";
import {
  priceNoAuthList,
  coalImportList,
  coalPlaceList,
  coalPortList,
  coalReceiptList,
  coalRateNoAuthList,
  industryNoAuthList,
  coalReportNoAuthList,
  bulletinList,
  industryDetail,
  coalReportDetail,
  addBulletin,
  coalRawYieldList,
  coalImportYieldList,
  mapAuth,
  stockNoAuthList,
  stockList,
  standardDetail,
  getAuthFlagCoal,
  getAuthDetailReport,
  getAuthSummaryReport,
  getAuthCompareReport
} from "@/api/coal";
import { chainList, forecastNoAuthList } from "@/api";
import { coalExamineNoAuthList } from "@/api/coal";
import CokeIndustrial from "@/components/bigChart/cokeIndustrial";

export default {
  name: "index",
  components: {
    ClassificationHeader,
    CokeIndustrial,
  },
  data() {
    return {
      // 价格预测
      forecastList: [],
      industrialFlag: false,
      industryListTabs: [],
      industryFlag: 5,
      show3: false,
      jiaotan: [],
      jiage: [],
      yanjiu: [],
      // 煤炭竞卖预告
      coalAuction: [],
      // 行业动态
      industryList: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      standardList: [],
      reportFlag: 2,
      // 价格指数
      priceFlag: 1,
      yieldFlag: 1,
      priceOneList: [],
      priceTwoList: [],
      priceThreeList: [],
      priceFourList: [],
      priceFiveList: [],
      // 库存
      stockFlag: "issue_coal_mine_stock",
      stockOneList: [],
      stockTwoList: [],
      stockThreeList: [],
      stockFourList: [],
      stockFiveList: [],
      // 开工率
      rateList: [],
      // 进出口量
      exitFlag: 1,
      exitOneList: [],
      exitTwoList: [],
      // 下游企业
      downstreamFlag: "issue_coal_company_day",
      downstreamList: [],
      downstreamTwoList: [],
      // 洗煤厂
      washFlag: "issue_coal_washcoke_rate",
      washList: [],
      washTwoList: [],
      washThreeList: [],
      // 新增淘汰产能
      boardList: [],
      // 讨论区
      bulletinList: [],
      yieldList: [],
      yieldListTwo: [],
      text: "",
      // 产业链
      chainTitle: "",
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      data8: {},
      chainPrice: {},
      option: {
        title: {
          // text: "ECharts 入门示例"
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          x: "center", //可设定图例在左、右、居中
          y: "bottom",
          data: ["产量"],
        },
        xAxis: {
          data: [],
        },
        yAxis: {},
        series: [
          {
            name: "产量",
            type: "line",
            data: [],
          },
        ],
        lineStyle: {
          color: "#F26D77", //改变折线颜色
        },
        grid: {
          x: 40,
          y: 25,
          x2: 10,
          y2: 50,
        },
      },
      optionCapacity: {
        title: {
          // text: "ECharts 入门示例"
        },
        tooltip: {},
        xAxis: {
          data: [],
        },
        yAxis: {},
        series: [
          {
            data: [],
            type: "bar",
            barWidth: 20, //柱图宽度
            itemStyle: {
              normal: {
                color: "#F26D77",
              },
            },
          },
        ],
        grid: {
          x: 60,
          y: 25,
          x2: 10,
          y2: 50,
        },
      },
      enterpriseList: [],
    };
  },
  created() {
    this.getHomeList();
  },
  methods: {
    /**
     * 外链
     */
    goCoalLink() {
      getAuthDetailReport().then((res) => {
        if (res.msg) {
          this.$router.push("/coal/relatedProductsCoal");
        }
      });
    },
    goReportServer(){
      getAuthCompareReport().then((res) => {
        if (res.msg) {
          this.$router.push("/coal/reportServer");
        }
      });
    },
    goReportSummary() {
      getAuthSummaryReport().then((res) => {
        if (res.msg) {
          this.$router.push("/coal/reportSummary");
        }
      });
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     * 切换tabs
     */
    changeFlag(flag) {
      this.industryFlag = flag;
    },
    /**
     * 获取首页信息
     */
    getHomeList() {
      // 价格预测
      forecastNoAuthList({ pageNum: 1, pageSize: 7, varieties: "焦煤" }).then(
        (res) => {
          this.forecastList = res.rows;
        }
      );
      coalExamineNoAuthList({ pageNum: 1, pageSize: 7 }).then((res) => {
        this.enterpriseList = res.rows;
      });
      // 产业链
      chainList({ dictDataType: "issue_coal_stell_chain_price" }).then(
        (res) => {
          this.chainTitle = res.data["data1"]["date"];
          this.data1 = res.data["data1"];
          this.data2 = res.data["data2"];
          this.data3 = res.data["data3"];
          this.data4 = res.data["data4"];
          this.data5 = res.data["data5"];
          this.data6 = res.data["data6"];
          this.data7 = res.data["data7"];
          this.data8 = res.data["data8"];
          this.chainPrice = res.data["price"];
        }
      );
      // 行业动态 1.焦炭，2.钢铁行业动态，3. 钢厂动态，4.煤炭行业要闻，5.煤炭快讯，6.国际钢联粗钢产量，, 7.中钢协冶金进出口、钢铁企业产存，8.宏观-宏观，9.宏观-黑色，10.宏观-化工，11.宏观-环保 118.煤炭竞卖预告
      industryNoAuthList({ pageNum: 1, pageSize: 8, sourceType: 5 }).then(
        (res) => {
          this.industryList = res.rows;
        }
      );
      industryNoAuthList({ pageNum: 1, pageSize: 8, sourceType: 4 }).then(
        (res) => {
          this.industryListTabs = res.rows;
        }
      );
      industryNoAuthList({ pageNum: 1, pageSize: 7, sourceType: 118 }).then(
        (res) => {
          this.coalAuction = res.rows;
        }
      );
      // 研究报告 1.焦炭，2.钢材，3.煤炭，4.醇醚，5.芳烃，6.碳材料
      this.reportList = [];
      coalReportNoAuthList({
        pageNum: 1,
        pageSize: 6,
        sourceType: 3,
        fileType: 1,
      }).then((res) => {
        this.reportList = res.rows;
      });
      coalReportNoAuthList({
        pageNum: 1,
        pageSize: 6,
        sourceType: 3,
        fileType: 2,
      }).then((res) => {
        this.reportListWeek = res.rows;
      });
      coalReportNoAuthList({
        pageNum: 1,
        pageSize: 6,
        sourceType: 3,
        fileType: 3,
      }).then((res) => {
        this.reportListMonth = res.rows;
      });
      // 技术标准
      coalReportNoAuthList({
        pageNum: 1,
        pageSize: 7,
        sourceType: 3,
        fileType: 4,
      }).then((res) => {
        this.standardList = res.rows;
      });
      // 价格指数
      coalPlaceList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_place_price",
        dataType: 1,
      }).then((res) => {
        this.priceOneList = res.rows;
      });
      coalPortList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_port_price",
        dataType: 1,
      }).then((res) => {
        this.priceTwoList = res.rows;
      });
      coalImportList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_import_price",
        dataType: 1,
      }).then((res) => {
        this.priceThreeList = res.rows;
      });
      coalReceiptList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_receipt_price",
        dataType: 1,
      }).then((res) => {
        this.priceFourList = res.rows;
      });
      priceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_contract_price",
        dataType: 1,
      }).then((res) => {
        this.priceFiveList = res.rows;
      });
      // 产量
      coalRawYieldList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_raw_yield",
        dataType: 2,
      }).then((res) => {
        this.yieldList = res.rows;
      });
      coalImportYieldList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_import_yield",
        dataType: 3,
      }).then((res) => {
        this.yieldListTwo = res.rows;
      });
      // 开工率
      stockNoAuthList({
        pageNum: 1,
        pageSize: 8,
        dictDataType: "manual_entry_show_coal_rate",
      }).then((res) => {
        this.rateList = res.rows;
      });
      // 库存
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_mine_stock",
      }).then((res) => {
        this.stockOneList = res.rows;
      });
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_port_stock",
      }).then((res) => {
        this.stockTwoList = res.rows;
      });
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_cokeplant_stock",
      }).then((res) => {
        this.stockThreeList = res.rows;
      });
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_steelplant_stock",
      }).then((res) => {
        this.stockFourList = res.rows;
      });
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_total_stock",
      }).then((res) => {
        this.stockFiveList = res.rows;
      });
      // 下游企业
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_company_total",
      }).then((res) => {
        this.downstreamList = res.rows;
      });
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_company_day",
      }).then((res) => {
        this.downstreamTwoList = res.rows;
      });
      // 洗煤厂
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_washcoke_rate",
      }).then((res) => {
        this.washList = res.rows;
      });
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_washcoke_stock",
      }).then((res) => {
        this.washTwoList = res.rows;
      });
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_washcoke_yield",
      }).then((res) => {
        this.washThreeList = res.rows;
      });
    },
    setScroll() {
      setTimeout(() => {
        this.$nextTick(() => {
          const waiceng = document.getElementById("waiceng");
          const neiwaiceng = document.getElementById("neiwaiceng");
          waiceng.scrollTop = neiwaiceng.clientHeight;
        });
      }, 200);
    },
    /**
     * 地图外链
     */
    goLink() {
      mapAuth().then(() => {
        window.openUrl("http://172.16.100.135:8066/Login/Index3", "_blank");
      });
    },
    /**
     * 下载文件
     */
    downloadReport(row) {
      coalReportDetail(row["id"] + "/1").then((res) => {
        this.$setMenuInfoPath(['焦煤', '研究报告', '正文'], row['id']);
      });
    },
    downloadStandard(row) {
      standardDetail(row["id"] + "/1").then((res) => {
        this.$setMenuInfoPath(['焦煤', '技术及标准', '正文'], row['id']);
      });
    },
    /**
     * 新增讨论区
     */
    addBtn() {
      if (!this.text) {
        this.$message.error("请输入内容");
        return;
      }
      addBulletin({ sourceType: 1, speakText: this.text }).then(() => {
        this.$message.success("留言成功！");
        this.text = "";
        bulletinList({ sourceType: 1 }).then((res) => {
          this.bulletinList = res.data;
          this.setScroll();
        });
      });
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({ path: `${url}`, query: { flag, num } });
    },
    reportToPage(url, flag) {
      this.$router.push({ path: url, query: { flag } });
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag, other) {
      this.$router.push({
        path: `${url}`,
        query: { id: id, flag: flag, other: other },
      });
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item["id"]).then(() => {
        window.openUrl(item.newsContent);
      });
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 地图配置加载
     */
    drawChart() {
      // 基于准备好的dom，初始化echarts实例【这里存在一个问题，请看到最后】
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      let myChartCapacity = this.$echarts.init(
        document.getElementById("myChartCapacity")
      );
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(this.option);
      // myChartBalance.setOption(optionBalance);
      myChartCapacity.setOption(this.optionCapacity);
    },
  },
};
</script>

<style scoped lang="less">
.coal_image {
  .coal_btn {
    position: relative;
    cursor: pointer;
    height: 140px;
    .coal_btn-bg {
      width: 100%;
      height: 100%;
    }
    .coal_btn-title {
      height: 33px;
      font-size: 24px;
      font-weight: 500;
      color: #ffffff;
      line-height: 33px;
      position: absolute;
      left: 17px;
      top: 24px;
      img {
        width: 70px;
        vertical-align: middle;
      }
    }
    .coal_btn-look {
      width: 72px;
      height: 24px;
      background: rgb(241, 137, 51);
      border-radius: 12px;
      position: absolute;
      top: 96px;
      left: 40px;
      text-align: center;
      line-height: 24px;
      span {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        line-height: 20px;
      }
    }
  }
}
.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #d3131a;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.priceBgc:nth-child(2n + 0) {
  background-color: #f2f2f2;
}

.priceBgc {
  padding: 0 15px;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/steel/banner.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      top: 30px;
      left: 272px;
    }

    .data1 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 29px;
      width: 106px;
      height: 50px;
    }

    .data2 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 179px;
      width: 106px;
      height: 50px;
    }

    .data3 {
      font-size: 4px;
      position: absolute;
      top: 251px;
      left: 176px;
      width: 115px;
      height: 50px;
    }

    .data4 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 345px;
      width: 106px;
      height: 50px;
    }

    .data5 {
      font-size: 10px;
      position: absolute;
      top: 39px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data6 {
      font-size: 10px;
      position: absolute;
      top: 128px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data7 {
      font-size: 10px;
      position: absolute;
      top: 215px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data8 {
      font-size: 10px;
      position: absolute;
      top: 305px;
      right: 18px;
      width: 119px;
      height: 50px;
    }

    .differPrice1 {
      position: absolute;
      top: 131px;
      left: 297px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice2 {
      position: absolute;
      top: 248px;
      left: 303px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice3 {
      position: absolute;
      top: 38px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice4 {
      position: absolute;
      top: 130px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice5 {
      position: absolute;
      top: 210px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice6 {
      position: absolute;
      top: 295px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
        cursor: pointer;
      }

      .title-write-red {
        color: #fff;
        background: #d3131a;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #d3131a;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #d3131a;
    border-bottom: 2px solid #d3131a;
  }
}

.tabs-i-hover {
  color: #d3131a;
  border-bottom: 2px solid #d3131a;
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    .last-li {
      border: 1px solid #cccccc;
      background: #f2f2f2;
      border-radius: 4px;
      width: 370px;

      .head {
        height: 40px;
        line-height: 40px;
        position: relative;
      }

      .classification-content {
        overflow: auto;
        height: 211px;
        border-bottom: 1px solid #ccc;
      }

      .footer {
        height: 44px;
        padding-top: 6px;

        input {
          width: 283px;
          height: 31px;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #cccccc;
          margin-left: 5px;
          padding-left: 10px;
        }

        .btn {
          cursor: pointer;
          display: inline-block;
          width: 61px;
          height: 34px;
          background: #cb081c;
          border-radius: 4px;
          vertical-align: middle;
          color: #fff;
          margin-left: 4px;
          text-align: center;
          line-height: 34px;
        }
      }
    }

    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;
        .coal_report {
          width: 70px;
          margin-left: 10px;
        }
        .red-title {
          width: 168px;
          height: 36px;
          background: #d3131a;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #cccccc;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #d3131a;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          width: 44px;
          vertical-align: middle;
          margin-right: 9px;
        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
          position: absolute;
          right: 0;
          top: 2px;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }
      .col_one {
        display: flex;
        flex-wrap: wrap;
        padding: 10px 0;
        box-sizing: border-box;
        .col_one-li {
          width: 100%;
          padding: 6px 0;
          .col_one-card {
            padding-left: 10px;
            border-radius: 10px;
            box-sizing: border-box;
            background: #F7F8FF;
            cursor: pointer;
            height: 60px;
            display: flex;
            align-items: center;
            .icon {
              flex-shrink: 0;
              width: 28px;
              height: 28px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .name {
              flex: 1;
              padding-left: 8px;
              width: 0;
              font-size: 14px;
              line-height: 21px;
            }
            &:hover{
              box-shadow: 0px 8px 10px 0px rgba(131,138,167,0.2);
              .name {
                color: #D3131A;
              }
            }
          }
        }
      }
      .classification-tabs-two {
        width: 74px;
        height: 40px;
        line-height: 40px;
        display: inline-block;
        background: #f2f2f2;
        border-top: 2px solid #f2f2f2;
        color: #222;
        text-align: center;
        cursor: pointer;
        vertical-align: top;
      }

      .classification-tabs-two-stock {
        width: 74px;
        height: 40px;
        line-height: 40px;
        display: inline-block;
        background: #f2f2f2;
        color: #222;
        text-align: center;
        cursor: pointer;
        vertical-align: top;
      }

      .priceFlag {
        border-top: 2px solid #d3131a;
        background-color: #fff;
      }

      .classification-tabs-two-stock:hover {
        background-color: #fff;
      }

      .classification-tabs-two:hover {
        border-top: 2px solid #d3131a;
        background-color: #fff;
      }

      .classification-tabs-three {
        width: 186px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #f2f2f2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .classification-tabs-three-wash {
        width: 124px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #f2f2f2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .classification-tabs-three-stock {
        width: 124px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #f2f2f2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        background-color: #d3131a !important;
        color: #fff !important;
      }

      .classification-tabs-three:hover {
        background-color: #d3131a;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9b857b;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            max-width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #d3131a;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            color: #777777;
            font-size: 12px;
          }
        }

        .price {
          height: 33px;
          line-height: 33px;

          img {
            width: 8px;
            margin-right: 5px;
          }
        }

        .map {
          height: 32px;
          line-height: 32px;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #dddddd;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n + 0) {
      margin-right: 0;
    }
  }
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
    word-break: break-all;
  }
}

.redColor {
  color: #ff6969;
}

.greenColor {
  color: #43e97b;
}
</style>
